import React, { Component, useContext, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import dogpic from './images/logo1.jpg'
import 'bootstrap/dist/css/bootstrap.css';
import './css_files/breed.css';
import { url } from "../weburl"
    ;
import axios from 'axios'
import { withRouter } from './pedigree_cards';
import { useState } from 'react';
import { dogUrlGenerator } from '../../util.js/dogUrlGenerator';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SearchSvg from './images/search-icon.svg'
import DogCard from './dog_card';
import CountryContext from './country_context';
import { ContentCutTwoTone } from '@mui/icons-material';
export const SearchNewForPage = (props) => {
    const [search_input, setSearchInput] = useState('')
    const [search_dogs, setSearchDogs] = useState({})
    const navigate = useNavigate()
    const context = useContext(CountryContext)


    useEffect(() => {

        if (props.searchUnderSpecificUser) {
            if (context.user && context.user_sql_details) {
                axios
                    .post(`${url}api/dogs/search/user`, { search_input: search_input, user: context.user_sql_details.id })
                    .then((res) => {
                        props.setDogs(res.data)
                    }
                    )
                    .catch((err) => console.log(err))
            }

        }
        else {
            axios
                .get(`${url}api/dogs/search/${search_input}`)
                .then((res) => {
                    props.setDogs(res.data)
                }
                )
                .catch((err) => console.log(err))
        }

    }, [search_input])

    const onInputChange = (e) => {
        setSearchInput(e.target.value)

    }



    return (


        <div className='w-100'>
            <div className='row align-items-center justify-content-center'>
                <div className="col-md-12">
                    <input type='search' class='search_input py-2 px-2'
                        name={props.name} value={search_input}
                        onChange={(e) => onInputChange(e)}
                        placeholder='Search for dog'></input>
                </div >


            </div>

        </div>



    )
}

